const slideList = [
  { id: 1, src: '/img/food/1.png', alt: '비빔밥 사진' },
  { id: 2, src: '/img/food/2.png', alt: '치킨 사진' },
  { id: 3, src: '/img/food/3.png', alt: '샐러드 사진' },
  { id: 4, src: '/img/food/4.png', alt: '피자 사진' },
  { id: 5, src: '/img/food/5.png', alt: '빙수 사진' },
  { id: 6, src: '/img/food/6.png', alt: '덮밥 사진' },
];

export default slideList;
